import React, { useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

interface MobileSliderProps {
  children: React.ReactNode;
}

const MobileSlider: React.FC<MobileSliderProps> = ({ children }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const autoplay = (slider: any) => {
    let timeout: ReturnType<typeof setTimeout>;
    let mouseOver = false;

    const clearNextTimeout = () => {
      clearTimeout(timeout);
    };

    const nextTimeout = () => {
      clearTimeout(timeout);

      if (mouseOver) return;

      timeout = setTimeout(() => {
        if (slider.track.details) {
          slider.next();
        }
      }, 3000);
    };

    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true;
        clearNextTimeout();
      });

      slider.container.addEventListener("mouseout", () => {
        mouseOver = false;
        nextTimeout();
      });

      nextTimeout();
    });

    slider.on("dragStarted", clearNextTimeout);
    slider.on("animationEnded", nextTimeout);
    slider.on("updated", nextTimeout);
    slider.on("destroyed", clearNextTimeout);
  };

  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>(
    {
      initial: 0,
      loop: true,
      slides: {
        perView: 1,
        spacing: 0,
      },
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
    },
    [autoplay],
  );

  return (
    <div className="container p-0 px-0-custom">
      <div ref={sliderRef} className="keen-slider">
        {React.Children.map(children, (child, index) => (
          <div key={index} className="keen-slider__slide w-full">
            {child}
          </div>
        ))}
      </div>

      {loaded && instanceRef.current && instanceRef.current.track.details && (
        <div className="flex justify-center items-center gap-2 px-[24px] pt-[32px] py-[24px] bg-transparent max-w-[244px] mx-auto">
          {Array.from({
            length: instanceRef.current.track.details.slides.filter(
              (slide: any) => !slide.clone,
            ).length,
          }).map((_, index) => (
            <button
              key={index}
              type="button"
              aria-label={`Go to slide ${index + 1}`}
              onClick={() => instanceRef.current?.moveToIdx(index)}
              className={`relative overflow-hidden p-0 ${
                currentSlide === index
                  ? "flex-1 min-w-[60px] h-1 bg-transparent"
                  : "flex-none w-4 h-1 bg-white"
              }`}
            >
              <span
                className={`absolute inset-0 h-1 ${
                  currentSlide === index
                    ? "bg-gradient-to-r from-[#8ABC00] to-[#0086E6] transition-all duration-[2000ms] delay-[200ms]"
                    : "-left-full"
                }`}
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileSlider;
